import { CartMain } from './CartMain';
import { useUpdateLiveData } from '../../interpreter/hooks';

export const CartPage = () => {
	useUpdateLiveData();

	return (
		<>
			<CartMain />
		</>
	);
};
